import * as uuid from 'uuid';
const UUID_LENGTH = 36;
export class UtilDocumentId {
    static generateId() {
        const crypto = typeof window !== "undefined" ? window.crypto : undefined;
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            return crypto.randomUUID();
        }
        else {
            const namespace = uuid.v4();
            const name = Math.random().toString();
            return uuid.v5(name, namespace);
        }
    }
    static isValid(id) {
        // start with an initial test of checking that the length is correct
        return id && id.length === UUID_LENGTH;
    }
}
